var exports = {
  "iE": "xaee3c4fa--4c3060--wrapper",
  "UC": "xaee3c4fa--4c3060--_loading",
  "Rf": "xaee3c4fa--4c3060--heading-wrapper",
  "vL": "xaee3c4fa--4c3060--items-wrapper",
};

module.exports = exports;
